var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(8781),
		__webpack_require__.e(2909)
	]).then(next);
};